import { Injectable } from '@angular/core';
import { RestCallService } from '../../../../core/services/rest-call/rest-call.service';
import { HttpClient } from '@angular/common/http';
import { ToastrService } from 'ngx-toastr';
import { NotificationService } from 'src/app/core/services/notification/notification.service';
import { TranslateApplicationService } from '../../../../core/translate/translate-application-service';
import { IProperties } from '../interfaces/IProperties';
import { ILastReleases } from '../interfaces/ILastReleases';

@Injectable({
	providedIn: 'root',
})
export class PropertiesService extends RestCallService {
	public dataToSend: IProperties = {
		pk_property: 0,
		property: '',
		property_value: '',
		description: '',
		creation_date: new Date(),
		str_creation_date: '',
		fk_employee_creator: 1,
		last_updated: new Date(),
		str_last_updated: '',
		fk_employee_updater: 1,
		employee_creator_name: '',
		employee_updater_name: '',
		username: '',
        available: false,
        fksite: 0
	};

	constructor(
		public httpClient: HttpClient,
		public toastr: ToastrService,
		public notificationService: NotificationService,
		public translate: TranslateApplicationService,
	) {
		super(httpClient, 'LockerLinkApi', toastr, notificationService, translate);
	}
  
  public GetPropertyAppVersion() {
		return this.post<IProperties[]>(
			'/api/Properties/GetPropertyAppVersion',
			this.dataToSend
		);
	}

	public GetPropertyByName(data: string) {
    	this.dataToSend.property = data;
    return this.post<IProperties[]>('/api/Properties/GetPropertyByName',this.dataToSend);
	}

	public GetLastReleases() {
		return this.post<ILastReleases[]>('/api/Properties/GetLastReleases');
	}
	
}
